import { Module } from 'vuex'
import { MessengerState } from '..'

export interface NetworkState {
  connected: boolean
  connectionType: 'wifi' | 'cellular' | 'none' | 'unknown'
}
export interface ApplicationState {
  isActive: boolean
  networkState: NetworkState
}

const appStateModule: Module<ApplicationState, MessengerState> = {
  namespaced: true,
  state: {
    isActive: true,
    networkState: { connected: true, connectionType: 'unknown' },
  },
  mutations: {
    setActive (state, isActive: boolean) {
      state.isActive = isActive
    },
    setNetworkState (state, networkState: NetworkState) {
      state.networkState = networkState
    },
  },
}

export default appStateModule

